import React, { useState } from 'react';
import cx from 'classnames';
import { ActionSearch } from './components/ActionSearch';
import styles from './style.module.css';

interface Props {
  value?: string | number;
  placeholder: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent) => void;
  hasValue?: boolean;
}

export const Search = ({
  value = '',
  placeholder,
  onChange,
  onClick,
  hasValue = false,
  ...props
}: Props) => {
  const [focus, setFocus] = useState(false);
  const containerSearch = cx('flex overflow-hidden br3 ba b--gray border-box', styles.h48);
  const onFocus = () => {
    setFocus(true);
  };
  const onBlur = () => {
    setFocus(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onClick(event);
    }
  };

  if (hasValue) {
    return (
      <div className={containerSearch}>
        <input
          placeholder={placeholder}
          className="f14 fw3 w-100 bn pl12 br3 mh0-ns abbey"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          value={value}
        />
        <ActionSearch value={value} focus={focus} onClick={onClick} />
      </div>
    );
  }

  return (
    <div className={containerSearch}>
      <input
        role="search"
        placeholder={placeholder}
        className="f14 fw3 w-100 bn pl12 br3 mh0-ns abbey"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        {...props}
      />
      <ActionSearch value={value} focus={focus} onClick={onClick} />
    </div>
  );
};
